export class UserOrderSummaryEntity {
  totalCompletedOrders?: number
  totalCanceledOrders?: number
  totalCompletedOrdersAmount?: number
}
